import {
  Button,
  Box,
  createStyles,
  Text,
  Select,
  TextInput,
  Modal,
} from "@mantine/core";
import swal from "sweetalert";
import { useEffect, useState } from "react";
import { IconChevronDown, IconDots } from "@tabler/icons-react";
import { useForm } from "@mantine/form";
import { useSelector } from "react-redux";
import { createpayer, getpayer, getpayerlist } from "../../services/payer";
import { useNavigate } from "react-router-dom";
import { stateZipCodes } from "../../utils/zipCodes";
// import { getdiagnosiscode } from "../../services/servicecode";

const useStyles = createStyles(() => ({
  mainbox: {
    background: " #F5F5F5",
    padding: "13px 19px",
  },
  addbox: {
    padding: "15px 13px 54px 13px",
    borderRadius: "16px",
    border: "1px solid #E5E5EA",
    background: "#FCFCFC",
  },

  width50: {
    width: "50%",
  },

  mainbtn: {
    display: "flex",
    gap: "10px",
    justifyContent: "flex-end",
    marginTop: "46px",
    marginBottom: "78px",
  },

  formRow: {
    width: "100%",
    display: "flex",
    gap: "17px",
    marginBottom: "20px",
    marginTop: "20px",
    "@media (max-width:1300px)": {
      flexDirection: "column",
      gap: "10px",
    },

    mt19: {
      marginTop: "19px",
    },

    boxtype: {
      display: "flex",
      flexDirection: "row",
    },

    flexend: {
      display: "flex",
      justifyContent: "flex-end",
    },
  },
  selectnumber: {
    width: "140px",
    padding: "5px 15px",
    borderRadius: "5px",
    backgroundColor: bgColor,
    // width: "50%",
    "& input": {
      backgroundColor: "transparent",
      border: "none",
      paddingInline: 0,
    },
  },

  line: {
    width: "2px",
    height: "42.011px",
    background: "#525252",
  },

  dflex: {
    display: "flex",
    justifyContent: "space-between",
  },

  boxnumber: {
    display: "flex",
    flexDirection: "row",
    width: "min-content",
    // justifyContent:'flex-end'
  },
}));
const bgColor = "#FFFFFF";

const CustomTextInput = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 15px",
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      backgroundColor: bgColor,
      "& input": {
        backgroundColor: "transparent",
        border: "none",
        paddingInline: 0,
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <TextInput {...rest} />
    </div>
  );
};

const CustomSelectBox = ({ ...rest }) => {
  const useStyles = createStyles((theme) => ({
    textInputBox: {
      width: "100%",
      padding: "5px 11px",

      backgroundColor: bgColor,
      borderRadius: "8px",
      border: "1px solid #E5E5E5",
      "& input": {
        border: "none",
        paddingInline: 0,
        backgroundColor: "transparent",
      },
    },
  }));
  const { classes } = useStyles();

  return (
    <div className={classes.textInputBox}>
      <Select
        {...rest}
        rightSection={<IconChevronDown color={"#94A3B8"} size={20} />}
        rightSectionWidth={25}
        styles={{ rightSection: { pointerEvents: "none" } }}
      />
    </div>
  );
};

function AddPayer({ state, setState, payerclient }) {
  const { classes } = useStyles();

  const { profile } = useSelector((state) => state?.profile);

  // const allpayer = useSelector((state) => state.payer?.allpayer?.payer);

  const handleClose = () => {
    setState((prevState) => ({
      ...prevState,
      addPayer: false,
    }));
  };

  const form = useForm({
    initialValues: {
      payerName: "",
      payerId: "",
      payerEntity: "",
      transaction: "",
      payerAddress1: "",
      payerAddress2: "",
      payerCity: "",
      payerState: "",
      payerZip: "",
    },
  });

  const updatestate = (res) => {
    if (res?.status === 200) {
      setState((prevState) => ({
        ...prevState,
        addProvider: false,
        addClient: true,
        addPayer: false,
      }));
    }
  };

  const onSave = async () => {
    // console.log('values',values);

    let values = form.values;

    // profile.user.id

    let missingFields = [];
    const optionalFields = [
      "payerAddress1",
      "payerAddress2",
      "payerEntity",
      "payerCity",
      "payerState",
      "payerZip",
    ];
    Object.entries(values)
      .filter(([key, _]) => !optionalFields.includes(key))
      .forEach(([key, value]) => !value && missingFields.push(key));

    if (missingFields.length > 0) {
      await swal({
        title: "Please fill out the following fields",
        text: missingFields.join(", "),
        icon: "warning",
        dangerMode: true,
      });
      return;
    }

    const selectedState = values.payerState?.trim();
    const enteredZipCode = values.payerZip?.trim();

    if (selectedState && enteredZipCode) {
      const stateZipCodeEntries = stateZipCodes.filter(
        (entry) => entry.ste_name === selectedState
      );

      const isZipValid = stateZipCodeEntries.some(
        (entry) => entry.zip_code === enteredZipCode
      );

      if (!isZipValid) {
        await swal({
          title: "Invalid Zip Code",
          text: `The zip code you entered is not valid for ${selectedState}. Please enter a valid zip code.`,
          icon: "warning",
          dangerMode: true,
        });
        return;
      }
    }

    let payload = {
      values,
        createdBy: profile.user.id,
        admin: profile?.user?.admin ?? profile?.user?.id,
    };

    console.log("payload", payload);

    const res = await createpayer(payload);

    console.log("res", res);

    // await updatestate(res);

    if (res.status === 200) {
      let payload={
        page:1
      }
      getpayer(payload);
      swal({
        title: `payer addded successfully`,
        text: "payer addded successfully",
        dangerMode: false,
      });
      form?.reset();
      handleClose();
    }
  };

  return (
    <Modal
      // className={classes.addMedicationModal}
      opened={state.addPayer}
      size={700}
      title="Add Payer"
      shadow="md"
      onClose={handleClose}
      overlayProps={{ blur: 3 }}
      radius={"md"}
      zIndex={1000}
      styles={{
        title: {
          color: "#000",
          fontSize: "24px",
          fontWeight: "700",
        },
      }}
      sx={{
        ".mantine-1fholi4": {
          color: "#000",
        },
        ".mantine-1ddebd9": {
          background: "#F5F5F5",
        },
        ".mantine-1fholi4:hover": {
          color: "#FFAF4A",
        },
        ".mantine-1q36a81": {
          padding: "0",
        },
      }}
      centered
    >
      <Box className={classes.mainbox}>
        <Text
          style={{ marginBottom: "9px", marginTop: "16px" }}
          ff={"Inter"}
          fz={16}
          fw={600}
          color="#171717"
        >
          Payer Information
        </Text>
        <Box className={classes.addbox}>
          <form onSubmit={form.onSubmit((values) => onSave(values))}>
            <div className={classes.formRow}>
              <Box style={{ width: "100%" }}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Payer Name
                </Text>

                {/* medication name */}
                <CustomTextInput
                  id="payername"
                  // label={"Facility Name"}
                  size="sm"
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  withAsterisk
                  {...form.getInputProps("payerName")}
                  // disabled={true}
                  // value={selectedPayer?.payername}
                />
              </Box>
            </div>

            <div style={{ marginTop: "19px" }} className={classes.formRow}>
              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  State
                </Text>

                <CustomSelectBox
                  id="state"
                  size="sm"
                  withAsterisk
                  data={Array.from(
                    new Set(stateZipCodes?.map((obj) => obj.ste_name))
                  )
                    ?.sort()
                    ?.map((ste_name) => ({
                      value: ste_name,
                      label: ste_name,
                    }))}
                  {...form.getInputProps("payerState")}
                  searchable
                />
              </Box>

              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  City
                </Text>

                {/* medication name */}
                <CustomTextInput
                  id="medication-name"
                  // label={"Facility Name"}
                  size="sm"
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  withAsterisk
                  {...form.getInputProps("payerCity")}
                  // disabled={isPreview}
                />
              </Box>
            </div>

            <div className={classes.formRow}>
              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Payer ID
                </Text>

                <CustomTextInput
                  id="medication-name"
                  // label={"Taxonomy/Speciality"}
                  size="sm"
                  // type="number"
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  withAsterisk
                  {...form.getInputProps("payerId")}
                  // disabled={true}
                  // value={selectedPayer?.payerid}
                />
              </Box>

              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Zip Code
                </Text>

                {/* <CustomSelectBox
                  id="zip-code"
                  type="number"
                  size="sm"
                  withAsterisk
                  disabled={!form?.values?.payerState}
                  data={
                    form?.values?.payerState
                      ? stateZipCodes
                          ?.filter(
                            (obj) => obj?.ste_name === form?.values?.payerState
                          )
                          ?.map((obj) => ({
                            value: obj?.zip_code,
                            label: obj?.zip_code,
                          }))
                      : []
                  }
                  {...form.getInputProps("payerZip")}
                  searchable
                /> */}

                <CustomTextInput
                  id="zip-code"
                  type="number"
                  // label={"Taxonomy/Speciality"}
                  size="sm"
                  // type="number"
                  // placeholder={"Enter Medication Name"}
                  // {...form.getInputProps("medicationName")}
                  withAsterisk
                  {...form.getInputProps("payerZip")}
                  // disabled={true}
                  // value={selectedPayer?.payerid}
                />
              </Box>
            </div>

            <div className={classes.formRow}>
              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Payer Entity
                </Text>

                <CustomSelectBox
                  id="billing-type"
                  placeholder={"Select Payer"}
                  withAsterisk
                  data={[
                    { value: "Medicare", label: "Medicare" },
                    { value: "Medicaid", label: "Medicaid" },
                    { value: "Tricare", label: "Tricare" },
                    { value: "ChampVA", label: "ChampVA" },
                    {
                      value: "Group Health Insurance",
                      label: "Group Health Insurance",
                    },
                    { value: "FEKA BLK LUNG", label: "FEKA BLK LUNG" },
                    { value: "Other", label: "Other" },
                  ]}
                  {...form.getInputProps("payerEntity")}
                />
              </Box>

              <Box className={classes.width50}>
                <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                  Transaction
                </Text>
                <CustomTextInput
                  id="transaction"
                  size="sm"
                  withAsterisk
                  {...form.getInputProps("transaction")}
                  // disabled={true}
                  // value={selectedPayer?.transaction}
                />
              </Box>
            </div>

            <Box>
              <Text ff={"Inter"} fz={14} fw={500} color="#344054">
                Address 1
              </Text>

              {/* medication name */}
              <CustomTextInput
                id="medication-name"
                // label={"Facility Name"}
                size="sm"
                // placeholder={"Enter Medication Name"}
                // {...form.getInputProps("medicationName")}
                withAsterisk
                {...form.getInputProps("payerAddress1")}
                // disabled={isPreview}
              />
            </Box>

            <Box mt={10}>
              <Text
                {...form.getInputProps("type")}
                ff={"Inter"}
                fz={14}
                fw={500}
                color="#344054"
              >
                Address 2
              </Text>

              {/* medication name */}
              <CustomTextInput
                id="medication-name"
                // label={"Facility Name"}
                size="sm"
                // placeholder={"Enter Medication Name"}
                // {...form.getInputProps("medicationName")}
                {...form.getInputProps("payerAddress2")}
                // disabled={isPreview}
              />
            </Box>
          </form>
        </Box>

        <Box className={classes.mainbtn}>
          <Button
            onClick={handleClose}
            variant="filled"
            c="#1D2939"
            radius="md"
            size="md"
            bg={"#F9FAFB"}
            style={{
              borderRadius: "8px",
              border: " 1px solid  #D0D5DD",
            }}
          >
            Cancel
          </Button>
          <Button
            // type="submit"
            onClick={onSave}
            variant="filled"
            c="#000"
            radius="md"
            size="md"
            color="yellow"
          >
            Submit
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}

export default AddPayer;
